export const AMR_METRIC_GROUP_LABELS: Record<string, string> = {
  "27_AMR": "Cardiorespiratory fitness",
  "26_AMR": "Lung",
  "19_AMR": "Posture",
  "12_AMR": "Respiratory function",
  "15_AMR": "Respiratory function",
  "17_AMR": "Performance",
  "10_AMR": "Heart",
  "11_AMR": "Metabolism",
  "3_AMR": "Mitochondria",
  "16_AMR": "Endurance",
  "18_AMR": "Recovery",
  "8_AMR": "Mitochondria",
};
